import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Child = JSX.Element | string | null;

type Props = {
  children: Child[] | Child;
  collapsible?: boolean;
  size?: 'normal' | 'small';
  text?: string;
};

const COLLAPSED_CHARACTER_LIMIT = 200;

function trim(text: string) {
  const cut = text.slice(0, COLLAPSED_CHARACTER_LIMIT);
  const lastSpace = cut.lastIndexOf(' ');

  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}

const Paragraph = ({ children, collapsible = false, size, text }: Props) => {
  const { t } = useTranslation();

  const [collapsed, setCollapsed] = useState(true);

  const preview =
    collapsible && text && text.length > COLLAPSED_CHARACTER_LIMIT
      ? trim(text)
      : undefined;

  return (
    <p
      className={`text-left ${
        size === 'small' ? 'text-sm leading-tight' : 'text-base leading-normal'
      }`}
    >
      {preview && collapsed ? preview : children}
      {preview && (
        <button
          type="button"
          className="ml-1 font-semibold underline"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? t('readMore') : t('readLess')}
        </button>
      )}
    </p>
  );
};

export default Paragraph;
